export enum TypeCompany {
  underwriter = 'underwriter',
  ratingAgency = 'ratingAgency',
  all = 'all',
}

export const DEFAULT_TTM_SELECT_VALUE = 'TTM';

export enum MapCompanyRole {
  underwriter = 'underwriter',
  'rating-agency' = 'ratingAgency',
}
